module.exports = __webpack_public_path__ + "static/media/image_part_003.701de5d1.jpg";